export default {
  bonus: {} as Object,
};
